import {TableTheme} from '@dv5/domain'

export const TABLE_THEME_LABELS: Record<TableTheme, string> = {
    [TableTheme.LIGHT]: 'Light',
    [TableTheme.DARK]: 'Dark',
    [TableTheme.OLD_PAPER]: 'Old Paper',
    [TableTheme.SOLAR]: 'Solar',
    [TableTheme.OLD_CONSOLE]: 'Old Console',
    [TableTheme.AMBER_TERMINAL]: 'Amber Terminal',
    [TableTheme.MIDNIGHT_BLUE]: 'Midnight Blue',
}

// Background color per theme, used for compact swatch buttons in the toolbar.
// Keep in sync with TABLE_THEME_STYLES in packages/canvas/services/widgetService.ts
export const TABLE_THEME_COLORS: Record<TableTheme, string> = {
    [TableTheme.LIGHT]: '#ffffff',
    [TableTheme.DARK]: '#1e1e1e',
    [TableTheme.OLD_PAPER]: '#f2e8dc',
    [TableTheme.SOLAR]: '#fdf6e3',
    [TableTheme.OLD_CONSOLE]: '#0c0c0c',
    [TableTheme.AMBER_TERMINAL]: '#0a0a0a',
    [TableTheme.MIDNIGHT_BLUE]: '#0f1b2d',
}
